<script>
import axios from 'axios'

export default {
  name: 'Newsletter',

  data() {
    return {
      form: {
        token: '',
        email: '',
      },

      errors: {},
      success: false,
      errorServer: false,
      successMessage: '',
    }
  },

  methods: {
    handleSubmit() {
      this.errorServer = false
      this.errors = {}
      this.success = false
      this.successMessage = ''

      this.$recaptcha('newsletter').then((token) => {
        this.form.token = token
        axios
          .post('/newsletter', this.form)
          .then((response) => {
            this.success = true
            this.successMessage = response.data.message
            this.form.email = ''
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {}
            } else if (error.response.status === 500 || error.response.status === 401) {
              this.errorServer = true
            }
          })
      })
    },
  },
}
</script>

<template>
  <div>
    <form
      class="mt-2 flex w-full flex-nowrap overflow-hidden rounded-md bg-white"
      @submit.prevent="handleSubmit">
      <label
        class="hidden"
        for="email"
        >{{ $t('footer.links.join.button') }}</label
      >
      <input
        id="email"
        v-model="form.email"
        class="w-full px-4 py-3 font-poppins text-xs placeholder-light/50"
        name="email"
        placeholder="example@example.com"
        required
        type="email" />
      <button
        class="whitespace-nowrap border-none bg-secondary px-4 py-2 font-sans text-xs font-bold text-white focus:outline-none"
        type="submit">
        {{ $t('footer.links.join.button') }}
      </button>
    </form>
    <span
      v-if="errors && errors['email']"
      class="text-xs text-red-500"
      >{{ errors['email'][0] }}</span
    >
    <span
      v-if="errors && errors['token']"
      class="text-xs text-red-500"
      >{{ errors['token'][0] }}</span
    >
    <span
      v-if="success && successMessage"
      class="text-xs text-emerald-500"
      >{{ successMessage }}</span
    >
  </div>
</template>
